import { TopzleApiClient } from "@topzle/api-client";
import { useAppStore } from "./state";
import { getSupabaseAccessToken } from "./supabase";
export const api = new TopzleApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? "http://localhost:8787",
  getAccessToken: async () =>
    (await getSupabaseAccessToken()) ?? useAppStore.getState().guest?.token ?? null,
});
